export const pullRequestsSeedData = [
    {
        id: 1,
        title: 'Feature: Add user profile page with avatar upload',
        number: 15,
        author: 'alice',
        createdAt: '1 day ago',
        state: 'open',
        labels: [
            { name: 'feature', color: '#a2eeef' },
            { name: 'frontend', color: '#d4c5f9' }
        ],
        comments: 8,
        additions: 245,
        deletions: 12,
        reviewStatus: 'approved'
    },
    {
        id: 2,
        title: 'Fix: Resolve memory leak in WebSocket connection',
        number: 14,
        author: 'bob',
        createdAt: '2 days ago',
        state: 'open',
        labels: [{ name: 'bug', color: '#d73a4a' }],
        comments: 3,
        additions: 89,
        deletions: 156,
        reviewStatus: 'changes-requested'
    },
    {
        id: 3,
        title: 'Refactor: Improve database query performance',
        number: 13,
        author: 'charlie',
        createdAt: '1 week ago',
        state: 'merged',
        labels: [{ name: 'performance', color: '#fbca04' }],
        comments: 15,
        additions: 320,
        deletions: 280,
        reviewStatus: 'approved'
    }
];
export const issuesSeedData = [
    {
        id: '1',
        repositoryId: 'repo1',
        title: 'Add support for dark mode toggle in settings',
        number: 42,
        description: 'We should add a dark mode toggle in the settings page',
        author: 'johndoe',
        authorAvatar: 'https://ui-avatars.com/api/?name=John+Doe&background=random',
        createdAt: '2 days ago',
        labels: [
            { id: '1', name: 'enhancement', color: '#a2eeef', description: 'New feature or request' },
            { id: '2', name: 'good first issue', color: '#7057ff', description: 'Good for newcomers' }
        ],
        comments: 5,
        state: 'open'
    },
    {
        id: '2',
        repositoryId: 'repo1',
        title: 'Fix authentication redirect loop',
        number: 41,
        description: 'Users are experiencing an infinite redirect loop after authentication',
        author: 'janedoe',
        authorAvatar: 'https://ui-avatars.com/api/?name=Jane+Doe&background=random',
        createdAt: '3 days ago',
        labels: [{ id: '3', name: 'bug', color: '#d73a4a', description: 'Something isn\'t working' }],
        comments: 12,
        state: 'open'
    },
    {
        id: '3',
        repositoryId: 'repo1',
        title: 'Update documentation for API endpoints',
        number: 40,
        description: 'The API documentation needs to be updated with the latest endpoints',
        author: 'docwriter',
        authorAvatar: 'https://ui-avatars.com/api/?name=Doc+Writer&background=random',
        createdAt: '5 days ago',
        labels: [{ id: '4', name: 'documentation', color: '#0075ca', description: 'Improvements or additions to documentation' }],
        comments: 3,
        state: 'closed'
    }
];
export const alertsSeedData = [
    {
        id: 1,
        type: 'vulnerability',
        severity: 'high',
        title: 'Prototype Pollution in lodash',
        description: 'Versions of lodash before 4.17.21 are vulnerable to prototype pollution.',
        createdAt: '3 days ago',
        status: 'open',
        affectedPackage: 'lodash@4.17.19'
    },
    {
        id: 2,
        type: 'code-scanning',
        severity: 'medium',
        title: 'Potential SQL injection vulnerability',
        description: 'User input is used directly in SQL query without sanitization.',
        createdAt: '1 week ago',
        status: 'fixed',
        affectedPackage: 'src/database/queries.ts'
    },
    {
        id: 3,
        type: 'secret',
        severity: 'critical',
        title: 'AWS Access Key detected',
        description: 'Hardcoded AWS credentials found in configuration file.',
        createdAt: '2 days ago',
        status: 'open',
        affectedPackage: 'config/aws.ts'
    }
];
export const completeRepositoryData2 = {
    ownerId: "user123",
    name: "backend",
    visibility: "public",
    watchCount: 12,
    starCount: 45,
    forkCount: 8,
    description: "Backend API for test application with deployment scripts",
    website: "https://example.com",
    stars: 45,
    issueCount: 3,
    prCount: 2,
    branch: "master",
    owner: {
        id: "user123",
        username: "gfn",
        avatarUrl: "",
    },
    lastCommit: {
        message: "bruno api to test && deploy docs",
        author: "Arthur-Kamau",
        time: "10 months ago",
        sha: "eb73deb",
    },
    files: [
        {
            name: ".idea",
            type: "folder",
            message: "improvements",
            updatedAt: "last year",
            children: [
                { name: "workspace.xml", type: "file", message: "IDE configuration", updatedAt: "last year" },
                { name: "modules.xml", type: "file", message: "IDE modules", updatedAt: "last year" },
                { name: "vcs.xml", type: "file", message: "Version control settings", updatedAt: "last year" },
            ]
        },
        {
            name: "app",
            type: "folder",
            message: "fix",
            updatedAt: "10 months ago",
            children: [
                { name: "main.go", type: "file", message: "Main application entry point", updatedAt: "10 months ago" },
                { name: "routes.go", type: "file", message: "API routes definition", updatedAt: "10 months ago" },
                { name: "handlers.go", type: "file", message: "Request handlers", updatedAt: "9 months ago" },
                { name: "middleware.go", type: "file", message: "Authentication middleware", updatedAt: "10 months ago" },
            ]
        },
        {
            name: "deploy",
            type: "folder",
            message: "bruno api to test && deploy docs",
            updatedAt: "10 months ago",
            children: [
                { name: "docker-compose.yml", type: "file", message: "Docker compose configuration", updatedAt: "10 months ago" },
                { name: "Dockerfile", type: "file", message: "Container image definition", updatedAt: "10 months ago" },
                { name: "nginx.conf", type: "file", message: "Nginx reverse proxy config", updatedAt: "10 months ago" },
                { name: "deploy.sh", type: "file", message: "Deployment script", updatedAt: "8 months ago" },
            ]
        },
        {
            name: "images",
            type: "folder",
            message: "env",
            updatedAt: "last year",
            children: [
                { name: "logo.png", type: "file", message: "Application logo", updatedAt: "last year" },
                { name: "banner.jpg", type: "file", message: "Banner image", updatedAt: "last year" },
                { name: "favicon.ico", type: "file", message: "Favicon", updatedAt: "last year" },
            ]
        },
        {
            name: "proto",
            type: "folder",
            message: "a ton of improvements",
            updatedAt: "last year",
            children: [
                { name: "user.proto", type: "file", message: "User service protobuf", updatedAt: "last year" },
                { name: "auth.proto", type: "file", message: "Authentication protobuf", updatedAt: "last year" },
                { name: "api.proto", type: "file", message: "Main API protobuf", updatedAt: "last year" },
            ]
        },
        { name: ".env", type: "file", message: "fix", updatedAt: "10 months ago" },
        { name: ".gitignore", type: "file", message: "fixes", updatedAt: "last year" },
        { name: "README.md", type: "file", message: "bruno api to test && deploy docs", updatedAt: "10 months ago" },
        { name: "backup.md", type: "file", message: "WIP: basics of app dadhboard in react", updatedAt: "last year" },
        { name: "env.sample", type: "file", message: "fixes", updatedAt: "last year" },
        { name: "go.mod", type: "file", message: "fixes", updatedAt: "last year" },
        { name: "go.sum", type: "file", message: "fixes", updatedAt: "last year" },
        { name: "main.go", type: "file", message: "csv to seed database as of 26 july 2024", updatedAt: "last year" },
        { name: "makefile", type: "file", message: "initial commit", updatedAt: "last year" },
        { name: "notes.md", type: "file", message: "fix", updatedAt: "last year" },
    ],
    readme: "# Backend API\n\nThis is the backend API for the application.\n\n## Features\n- REST API\n- Authentication\n- Database integration",
    languages: [
        { name: "Go", percentage: 85.2, color: "#00ADD8" },
        { name: "Shell", percentage: 10.5, color: "#89e051" },
        { name: "Makefile", percentage: 4.3, color: "#427819" },
    ],
};
export const completeRepositoryData = {
    ownerId: "user123",
    name: "backend",
    visibility: "public",
    watchCount: 12,
    starCount: 45,
    forkCount: 8,
    description: "Backend API for test application with deployment scripts",
    website: "https://example.com",
    stars: 45,
    issueCount: 3,
    prCount: 2,
    branch: "master",
    owner: {
        id: "user123",
        username: "gfn",
        avatarUrl: "",
    },
    lastCommit: {
        message: "bruno api to test && deploy docs",
        author: "Arthur-Kamau",
        time: "10 months ago",
        sha: "eb73deb",
    },
    files: [
        {
            name: ".idea",
            type: "folder",
            message: "improvements",
            updatedAt: "last year",
            children: [
                {
                    name: "workspace.xml",
                    type: "file",
                    message: "IDE configuration",
                    updatedAt: "last year",
                },
                {
                    name: "modules.xml",
                    type: "file",
                    message: "IDE modules",
                    updatedAt: "last year",
                },
                {
                    name: "vcs.xml",
                    type: "file",
                    message: "Version control settings",
                    updatedAt: "last year",
                },
            ],
        },
        {
            name: "app",
            type: "folder",
            message: "fix",
            updatedAt: "10 months ago",
            children: [
                {
                    name: "main.go",
                    type: "file",
                    message: "Main application entry point",
                    updatedAt: "10 months ago",
                },
                {
                    name: "routes.go",
                    type: "file",
                    message: "API routes definition",
                    updatedAt: "10 months ago",
                },
                {
                    name: "handlers.go",
                    type: "file",
                    message: "Request handlers",
                    updatedAt: "9 months ago",
                },
                {
                    name: "middleware.go",
                    type: "file",
                    message: "Authentication middleware",
                    updatedAt: "10 months ago",
                },
                {
                    name: "assets",
                    type: "folder",
                    message: "fix",
                    updatedAt: "10 months ago",
                    children: [
                        {
                            name: "s.png",
                            type: "file",
                            message: "Main application entry point",
                            updatedAt: "10 months ago",
                        },
                    ],
                },
            ],
        },
        {
            name: "deploy",
            type: "folder",
            message: "bruno api to test && deploy docs",
            updatedAt: "10 months ago",
            children: [
                {
                    name: "docker-compose.yml",
                    type: "file",
                    message: "Docker compose configuration",
                    updatedAt: "10 months ago",
                },
                {
                    name: "Dockerfile",
                    type: "file",
                    message: "Container image definition",
                    updatedAt: "10 months ago",
                },
                {
                    name: "nginx.conf",
                    type: "file",
                    message: "Nginx reverse proxy config",
                    updatedAt: "10 months ago",
                },
                {
                    name: "deploy.sh",
                    type: "file",
                    message: "Deployment script",
                    updatedAt: "8 months ago",
                },
            ],
        },
        {
            name: "images",
            type: "folder",
            message: "env",
            updatedAt: "last year",
            children: [
                {
                    name: "logo.png",
                    type: "file",
                    message: "Application logo",
                    updatedAt: "last year",
                },
                {
                    name: "banner.jpg",
                    type: "file",
                    message: "Banner image",
                    updatedAt: "last year",
                },
                {
                    name: "favicon.ico",
                    type: "file",
                    message: "Favicon",
                    updatedAt: "last year",
                },
            ],
        },
        {
            name: "proto",
            type: "folder",
            message: "a ton of improvements",
            updatedAt: "last year",
            children: [
                {
                    name: "user.proto",
                    type: "file",
                    message: "User service protobuf",
                    updatedAt: "last year",
                },
                {
                    name: "auth.proto",
                    type: "file",
                    message: "Authentication protobuf",
                    updatedAt: "last year",
                },
                {
                    name: "api.proto",
                    type: "file",
                    message: "Main API protobuf",
                    updatedAt: "last year",
                },
            ],
        },
        {
            name: ".env",
            type: "file",
            message: "fix",
            updatedAt: "10 months ago",
        },
        {
            name: ".gitignore",
            type: "file",
            message: "fixes",
            updatedAt: "last year",
        },
        {
            name: "README.md",
            type: "file",
            message: "bruno api to test && deploy docs",
            updatedAt: "10 months ago",
        },
        {
            name: "backup.md",
            type: "file",
            message: "WIP: basics of app dadhboard in react",
            updatedAt: "last year",
        },
        {
            name: "env.sample",
            type: "file",
            message: "fixes",
            updatedAt: "last year",
        },
        {
            name: "go.mod",
            type: "file",
            message: "fixes",
            updatedAt: "last year",
        },
        {
            name: "go.sum",
            type: "file",
            message: "fixes",
            updatedAt: "last year",
        },
        {
            name: "main.go",
            type: "file",
            message: "csv to seed database as of 26 july 2024",
            updatedAt: "last year",
        },
        {
            name: "makefile",
            type: "file",
            message: "initial commit",
            updatedAt: "last year",
        },
        {
            name: "notes.md",
            type: "file",
            message: "fix",
            updatedAt: "last year",
        },
    ],
    readme: "# Backend API\n\nThis is the backend API for the application.\n\n## Features\n- REST API\n- Authentication\n- Database integration",
    languages: [
        { name: "Go", percentage: 85.2, color: "#00ADD8" },
        { name: "Shell", percentage: 10.5, color: "#89e051" },
        { name: "Makefile", percentage: 4.3, color: "#427819" },
    ],
};
